export const useCurrentUID = (usePseudoLoginId: boolean = true) => {
  const pseudoLoginStore = usePseudoLogin();

  if (usePseudoLoginId && pseudoLoginStore.isPseudoLogin == true) {
    return pseudoLoginStore.pseudoId;
  }

  const user = useCurrentUser();

  if (user.value?.uid == undefined && useAppUserDataStore().isLoggedIn != true) {
    return "-";
  }

  return user.value?.uid;
};
